import Vue from "vue";
// 引入大数据表格 - 虚拟滚动
import XEUtils from "xe-utils";
import { VXETable, Icon, Header, Column, Edit, Table,Tooltip } from "vxe-table";
import enUS from "vxe-table/lib/locale/lang/en-US";

// 按需加载的方式默认是不带国际化的，需要自行导入
VXETable.setup({
  // 使用 vue-i18n 解析占位符 '{xx}'
  //i18n: (key, args) => i18n.t(key, args),
  // 使用 xe-utils 解析占位符 '{xx}'
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(enUS, key), args),
});
import {
  commonTable,
  commonPagination,
  commonHeader,
  commoninputSearch,
  commonInputSelect,
  commonInputDate,
  commonDialog,
  commonInput,
  commonMultipleSelectCheckbox,
  commonMultipleSelectCheckboxV2,
  commonAddHeader,
  commonTimePicker,
  commonInputAutocomplete,
  commonDiamondPrompt,
  commonCenterDialog,
  commonCenterDialogV2,
  commonForm,
  commonSteps,
  commonTimeSelect,
  commonNav,
  commonEllipsisTooltip,
  commonCascder
} from "../components-v2/index";
const componentsV2 = [
  commonTable,
  commonPagination,
  commonHeader,
  commoninputSearch,
  commonInputSelect,
  commonInputDate,
  commonDialog,
  commonInput,
  commonMultipleSelectCheckbox,
  commonMultipleSelectCheckboxV2,
  commonAddHeader,
  commonTimePicker,
  commonInputAutocomplete,
  commonDiamondPrompt,
  commonCenterDialog,
  commonCenterDialogV2,
  Header,
  Column,
  Icon,
  Edit,
  Table,
  Tooltip,
  commonSteps,
  commonForm,
  commonTimeSelect,
  commonNav,
  commonEllipsisTooltip,
  commonCascder
];

componentsV2.forEach((com) => {
  Vue.use(com);
});
